module.exports = __webpack_public_path__ + "a34c30ceadf2868768257d59a018e39d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/apps/memorie.png
// module id = 509
// module chunks = 0